import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslations } from "../../i18n";
import { useUserWaitlistBookings } from "./use-user-waitlist-bookings";
import { api, ApiError } from "@/lib/api";
import { track } from "@/lib/analytics";

export function useWaitlistJoin() {
  const [isJoining, setIsJoining] = useState(false);
  const t = useTranslations("calendar");
  const { refresh } = useUserWaitlistBookings();

  const joinWaitlist = async (classSessionId: string) => {
    if (isJoining) return;
    setIsJoining(true);

    try {
      // Par api() : il joint le jeton du widget. Un fetch nu ne comptait que
      // sur le cookie, refuse comme cookie tiers par Safari (401).
      let data: { position?: number; alreadyWaitlisted?: boolean };
      try {
        data = await api("/api/widget/waitlist/join", {
          method: "POST",
          body: JSON.stringify({ classSessionId }),
        });
      } catch (error) {
        // api() a deja deconnecte sur un 401 : rien a signaler de plus.
        if (error instanceof ApiError && error.status === 401) return;
        throw error;
      }

      if (!data.alreadyWaitlisted) {
        track("waitlist_joined", {
          class_session_id: classSessionId,
          position: data.position ?? null,
        });
      }

      if (data.alreadyWaitlisted) {
        const msg = t("waitlistPosition").replace("{{position}}", String(data.position ?? ""));
        toast(msg, { icon: "⏳" });
      } else {
        toast.success(t("waitlistJoined"));
      }

      await refresh();
    } catch {
      toast.error(t("waitlistError"));
    } finally {
      setIsJoining(false);
    }
  };

  return { joinWaitlist, isJoining };
}
